(function () {
  if (window.DrinksiltThemeManager && window.DrinksiltThemeManager.initialized) {
    return;
  }

  var STORAGE_KEY = 'drinksilt-theme';

  /* The three selectable modes. "both" = AM+PM combined. */
  var SELECTIONS = ['morning', 'night', 'both'];

  /* Product pages are the agency's build and carry their own palette.
     Everywhere else (the homepage) keeps the SILT palette and opens on
     Combo. */
  var IS_PRODUCT_PAGE = window.location.pathname.indexOf('/products/') !== -1;

  /* What a first-time homepage visitor lands on. Combo is the product
     story: the page is meant to open on AM+PM, not on whichever half the
     clock happens to point at. */
  var DEFAULT_SELECTION = 'both';

  var sitePalettes = {
    morning: {
      background: '#FFF8EC',
      foreground: '#2B2317',
      accent: '#EBB858',
      accentDeep: '#C37E2C',
      accentGradient: 'linear-gradient(180deg, #FFE6A6 0%, #F9E1A8 100%)',
      tint: '#F9E1A8',
      ink: '#2B2317',
      surface: '#FEF7E1',
      border: 'rgba(68, 37, 7, 0.10)',
      contrastBorder: 'rgba(68, 37, 7, 0.18)',
      surfaceStrong: 'rgba(68, 37, 7, 0.08)',
      buttonText: '#2B2317',
      headerSurface: '#FEF7E1'
    },
    night: {
      background: '#081635',
      foreground: '#F2EFE6',
      accent: '#254484',
      accentDeep: '#0A1737',
      accentGradient: 'linear-gradient(180deg, #5475BA 0%, #254484 100%)',
      tint: '#F2EFE6',
      ink: '#0A1737',
      surface: '#081635',
      border: 'rgba(220, 231, 255, 0.10)',
      contrastBorder: 'rgba(220, 231, 255, 0.18)',
      surfaceStrong: 'rgba(220, 231, 255, 0.12)',
      buttonText: '#F2EFE6',
      headerSurface: '#081635'
    },
    /* AM + PM combined: warm neutral base, dual-tone accent. */
    both: {
      background: '#FAF4EA',
      foreground: '#2B2317',
      accent: '#E8A21A',
      accentDeep: '#254484',
      accentGradient: 'linear-gradient(90deg, #EBB858 0%, #254484 100%)',
      tint: '#E9DFF2',
      ink: '#2B2317',
      surface: '#FEF7E1',
      border: 'rgba(43, 35, 23, 0.12)',
      contrastBorder: 'rgba(43, 35, 23, 0.20)',
      surfaceStrong: 'rgba(43, 35, 23, 0.08)',
      buttonText: '#2B2317',
      headerSurface: '#FEF7E1'
    }
  };
  var pdpPalettes = {
    morning: {
      background: '#FFF8EC',
      foreground: '#442507',
      accent: '#F6A900',
      accentDeep: '#E09400',
      accentGradient: 'linear-gradient(180deg, #FFE6A6 0%, #F7D487 100%)',
      tint: '#F7D487',
      ink: '#442507',
      surface: '#FFF9EE',
      border: 'rgba(68, 37, 7, 0.10)',
      contrastBorder: 'rgba(68, 37, 7, 0.18)',
      surfaceStrong: 'rgba(68, 37, 7, 0.08)',
      buttonText: '#442507',
      headerSurface: '#FFF9EE'
    },
    night: {
      background: '#071432',
      foreground: '#DCE7FF',
      accent: '#31559E',
      accentDeep: '#0A1737',
      accentGradient: 'linear-gradient(180deg, #5475BA 0%, #31559E 100%)',
      tint: '#DCE7FF',
      ink: '#0A1737',
      surface: '#071432',
      border: 'rgba(220, 231, 255, 0.10)',
      contrastBorder: 'rgba(220, 231, 255, 0.18)',
      surfaceStrong: 'rgba(220, 231, 255, 0.12)',
      buttonText: '#DCE7FF',
      headerSurface: '#071432'
    },
    /* AM + PM combined: warm neutral base, dual-tone accent. */
    both: {
      background: '#FAF4EA',
      foreground: '#2B2317',
      accent: '#E8A21A',
      accentDeep: '#31559E',
      accentGradient: 'linear-gradient(90deg, #F6A900 0%, #31559E 100%)',
      tint: '#E9DFF2',
      ink: '#2B2317',
      surface: '#FFFBF4',
      border: 'rgba(43, 35, 23, 0.12)',
      contrastBorder: 'rgba(43, 35, 23, 0.20)',
      surfaceStrong: 'rgba(43, 35, 23, 0.08)',
      buttonText: '#2B2317',
      headerSurface: '#FFFBF4'
    }
  };
  var palettes = IS_PRODUCT_PAGE ? pdpPalettes : sitePalettes;


  function getAutoTheme() {
    var hour = new Date().getHours();
    return hour >= 6 && hour < 18 ? 'morning' : 'night';
  }

  /* Normalise anything (am/pm/day/dark/am+pm...) into a valid selection. */
  function normalizeSelection(value) {
    var v = String(value || '').trim().toLowerCase();
    if (!v) return '';

    if (
      v === 'both' || v === 'am+pm' || v === 'ampm' ||
      v === 'am + pm' || v === 'combined' || v === 'all'
    ) return 'both';

    if (
      v === 'night' || v === 'pm' || v === 'evening' || v === 'dark'
    ) return 'night';

    if (
      v === 'morning' || v === 'am' || v === 'day' || v === 'light'
    ) return 'morning';

    return '';
  }

  function getStoredTheme() {
    try {
      return normalizeSelection(window.localStorage.getItem(STORAGE_KEY));
    } catch (error) {
      return '';
    }
  }

  function setStoredTheme(selection) {
    try {
      window.localStorage.setItem(STORAGE_KEY, selection);
    } catch (error) {}
  }

  function updateThemeButtons(selection) {
    document.querySelectorAll('[data-drinksilt-theme-set]').forEach(function (button) {
      var target = normalizeSelection(button.getAttribute('data-drinksilt-theme-set'));
      var active = target === selection;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function applyTheme(rawSelection) {
    var selection = normalizeSelection(rawSelection) || getAutoTheme();

    /* For "both" we still expose a binary value so every existing section
       that only understands morning|night keeps rendering sensibly. */
    var resolved = selection === 'both' ? getAutoTheme() : selection;

    var palette = palettes[selection] || palettes[resolved];
    var root = document.documentElement;
    var body = document.body;

    /* Backwards-compatible attribute: always morning|night. */
    root.dataset.drinksiltTheme = resolved;
    /* New attribute: the actual user selection, incl. "both". */
    root.dataset.drinksiltSelect = selection;

    if (body) {
      body.dataset.drinksiltTheme = resolved;
      body.dataset.drinksiltSelect = selection;
    }

    root.style.setProperty('--drinksilt-header-surface', palette.headerSurface);
    root.style.setProperty('--drinksilt-theme-background', palette.background);
    root.style.setProperty('--drinksilt-theme-foreground', palette.foreground);
    root.style.setProperty('--drinksilt-theme-accent', palette.accent);
    root.style.setProperty('--drinksilt-theme-accent-deep', palette.accentDeep);
    root.style.setProperty('--drinksilt-theme-accent-gradient', palette.accentGradient);
    root.style.setProperty('--drinksilt-theme-tint', palette.tint);
    root.style.setProperty('--drinksilt-theme-ink', palette.ink);
    root.style.setProperty('--drinksilt-theme-surface', palette.surface);
    root.style.setProperty('--drinksilt-theme-border', palette.border);
    root.style.setProperty('--drinksilt-theme-contrast-border', palette.contrastBorder);
    root.style.setProperty('--drinksilt-theme-surface-strong', palette.surfaceStrong);
    root.style.setProperty('--drinksilt-theme-button-text', palette.buttonText);

    if (body) {
      body.style.backgroundColor = palette.background;
      body.style.color = palette.foreground;
    }

    updateThemeButtons(selection);

    /* Let any section opt in to richer behaviour without polling. */
    document.dispatchEvent(new CustomEvent('drinksilt:themechange', {
      detail: { selection: selection, resolved: resolved }
    }));
  }

  function resolveInitialTheme() {
    var header = document.querySelector('[data-drinksilt-header]');
    var mode = header ? (header.getAttribute('data-theme-mode') || 'auto') : 'auto';
    var stored = getStoredTheme();

    if (mode === 'auto') {
      /* Homepage always opens on Combo. The stored choice used to win
         here, so a reload landed on whichever half was clicked last and
         the page appeared to change its mind. Product pages keep the
         agency's behaviour: last pick, else the clock. */
      return IS_PRODUCT_PAGE ? (stored || getAutoTheme()) : DEFAULT_SELECTION;
    }

    return normalizeSelection(mode) || getAutoTheme();
  }

  function init() {
    applyTheme(resolveInitialTheme());

    document.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('[data-drinksilt-theme-set]');
      if (!button) return;

      var selected = normalizeSelection(button.getAttribute('data-drinksilt-theme-set'));
      if (SELECTIONS.indexOf(selected) === -1) return;

      var previous = document.documentElement.dataset.drinksiltSelect || '';
      setStoredTheme(selected);
      applyTheme(selected);
      if (selected !== previous) trackToggle(button, previous, selected);
    });
  }

  /* Toggle switches to GA4 + Clarity (4 Nov 2026, her ask: how many people
     switch Combo / Nights / Mornings). One event name per mode picked
     (silt_toggle_combo / _nights / _mornings) so GA4 counts them by event name
     with no custom dimension set up; from, where and page ride along as params.
     Only a real switch counts, not a tap on the mode already showing. */
  function trackToggle(button, previous, selected) {
    try {
      var NAMES = { both: 'combo', night: 'nights', morning: 'mornings' };
      var section = button.closest('.shopify-section');
      var where = section && section.id ? section.id.replace(/^shopify-section-(template|sections)--\d+__/, '') : 'other';
      var params = { toggle_from: NAMES[previous] || 'none', toggle_where: where, page_path: window.location.pathname };
      var name = 'silt_toggle_' + NAMES[selected];
      if (typeof window.siltTrack === 'function') window.siltTrack(name, params);
      else {
        window.dataLayer = window.dataLayer || [];
        (function () { window.dataLayer.push(arguments); })('event', name, Object.assign({ send_to: 'G-D4WQW65YC5' }, params));
      }
      if (typeof window.clarity === 'function') {
        window.clarity('event', name);
        window.clarity('set', 'toggled', 'yes');
      }
    } catch (error) {}
  }

  window.DrinksiltThemeManager = {
    initialized: true,
    selections: SELECTIONS,
    palettes: palettes,
    defaultSelection: DEFAULT_SELECTION,
    isProductPage: IS_PRODUCT_PAGE,
    getAutoTheme: getAutoTheme,
    normalizeSelection: normalizeSelection,
    getStoredTheme: getStoredTheme,
    setStoredTheme: setStoredTheme,
    applyTheme: applyTheme,
    resolveInitialTheme: resolveInitialTheme,
    getSelection: function () {
      return document.documentElement.dataset.drinksiltSelect || '';
    },
    init: init
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
